import constant from './constant';

const initialState = {
    activeNavItem : 'accounts'
};

export const sideNavItemReducer = (state = initialState , action)=> {
    switch(action.type){
        case constant.CHANGE_SIDE_ITEM: return {activeNavItem: action.payload};
        case constant.CLEAN_UP_ITEM: return initialState;
        default: return state;
    }
};

